import styled, { css } from 'styled-components';
import { getTextStyle } from '../../../../generic/content/texts/bou-text/text-style';
import { BouColor } from '../../../../generic/global/bou-colors';
import { themeDEPRECATED } from '../../../../generic/global/styles';
import { BouSpacingLevel, fluidSpacing } from '../../../../generic/layout/bou-spacing';

export interface CellProps {
  hideBreakpoint?: number;
  selected?: boolean;
  disabled?: boolean;
  styleOverride?: string;
}

interface TableProps {
  enableRowSelection?: boolean;
  styleOverride?: string;
}

export const Table = styled.table<TableProps>`
  ${props => props.styleOverride || getDefaultTableStyle(props)};
`;

export function getDefaultTableStyle(props?: TableProps) {
  return css`
      font-size: 14px;
      width: 100%;
      border-collapse: collapse;
      color: ${BouColor.TOOL_TEXT_BLACK};

      thead td {
          cursor: pointer;
          border-bottom: 1px solid ${BouColor.BLACK_TOTAL};
      }

      td {
          padding-left: 0;
          padding-right: 0;
      }

      tbody td {
          cursor: ${props?.enableRowSelection ? 'pointer' : 'text'};
          padding-top: 12px;
          padding-bottom: 12px;
          border-top: 1px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY};
      }

      tbody tr:hover td {
          background-color: ${props?.enableRowSelection ? BouColor.TOOL_TABLE_HOVER_GRAY : 'transparent'};
      }

      tbody tr:first-child td {
          padding-top: 12px;
      }
  `;
}

export const HeaderCell = styled.td<CellProps>`
  ${getTextStyle({ size: 'xxs', isBold: true })}
  ${fluidSpacing('padding-bottom', BouSpacingLevel.MICRO)}
  text-align: center;
  vertical-align: bottom;
  @media (max-width: ${props => props.hideBreakpoint}px) {
    display: none;
  }
`;

export const FooterCell = styled.td<CellProps>`
  text-transform: uppercase;
  text-align: center;
  ${themeDEPRECATED.fontSemiBold};
  /* padding-top: ${themeDEPRECATED.rhythm(3)}; */
  padding-bottom: ${themeDEPRECATED.rhythm(3)};
  vertical-align: top;
  cursor: default;
  @media (max-width: ${props => props.hideBreakpoint}px) {
    display: none;
  }
  ${props => props.styleOverride}
`;

export const CenteredCell = styled.td<CellProps>`
  text-align: center;
  transition: background-color 0.25s ease-in-out;
  ${(props: CellProps) => (props.disabled ? `color: ${BouColor.TOOL_TEXT_LIGHT_GRAY} !important` : '')};
  background-color: ${(props: CellProps) =>
    props.selected ? `${BouColor.TOOL_TABLE_SELECTED_YELLOW} !important` : 'transparent'};
`;

export const NumberCell = styled.td<CellProps>`
  font-feature-settings: 'lnum', 'tnum';
  width: 150px;
  text-align: right;
  @media (max-width: ${props => props.hideBreakpoint}px) {
    display: none;
  }
  ${(props: CellProps) => (props.disabled ? `color: ${BouColor.TOOL_TEXT_LIGHT_GRAY} !important` : '')};
  a,
  a:visited {
    color: ${BouColor.TOOL_TEXT_BLACK};
    text-decoration: none;
  }
  transition: background-color 0.25s ease-in-out;
  background-color: ${(props: CellProps) =>
    props.selected ? `${BouColor.TOOL_TABLE_SELECTED_YELLOW} !important` : 'transparent'};
`;

export const CenteredNumberCell = styled(NumberCell)`
  text-align: center;
`;

export const TextCell = styled.td<CellProps>`
  text-align: left;
  @media (max-width: ${props => props.hideBreakpoint}px) {
    display: none;
  }

  ${(props: CellProps) => (props.disabled ? `color: ${BouColor.TOOL_TABLE_TEXT_DISABLED_GRAY} !important` : '')};

  a {
    color: ${BouColor.TOOL_TEXT_BLACK};
    text-decoration: none;
  }
  a:visited {
    color: ${BouColor.TOOL_TEXT_BLACK};
  }
  transition: background-color 0.25s ease-in-out;
  background-color: ${(props: CellProps) =>
    props.selected ? `${BouColor.TOOL_TABLE_SELECTED_YELLOW} !important` : 'transparent'};
`;

export const TitleCell = styled(TextCell)``;
